/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

/*eslint new-cap:0*/

var Intent = require('../intent'),
    systemPlayer = require('../system.player'),
    spinner      = require('../ui/spinner'),
    drawProgress = require('./progress.canvas'),
    currentAd,
    timer,
    player = {};


function setProgress () {
    var progressSec = systemPlayer.primary.position,
        progress = progressSec / systemPlayer.primary.duration * 100;


    if ( currentAd.onRequiredWatch && progressSec >= currentAd.requiredPart ) {
        currentAd.onRequiredWatch();
        currentAd.onRequiredWatch = null;
    }

    if ( progress >= 25 && currentAd.quarter ) {
        currentAd.quarter();
    }

    if ( progress >= 50 && currentAd.middle ) {
        currentAd.middle();
    }

    if ( progress >= 75 && currentAd.thirdQuarter ) {
        currentAd.thirdQuarter();
    }
    drawProgress(progress);
}

/**
 * Start playing advertising
 *
 * @param {Object} config - config object
 * @param {Function} callback - callback  after watching video
 */
player.play = function ( config, callback ) {
    var url = config.url,
        intent;

    if ( DEVELOP ) {
        url = 'http://www.w3schools.com/html/mov_bbb.mp4';
    }

    currentAd = config;

    console.log('PLAY uri: ' + url);

    intent = new Intent({
        action: 'play',
        data: {
            uri: url
        },
        mime: 'advertising',
        events: {
            start: function () {
                console.log('play advertising start event');
                timer = setInterval(setProgress, 1000);
                spinner.hide();
            },
            end: function () {
                console.log('play advertising end event');
                clearInterval(timer);
                drawProgress.clear();
                spinner.hide();
                callback();
            },
            error: function () {
                console.log('play advertising error event');
                clearInterval(timer);
                drawProgress.clear();
                spinner.hide();
                callback();
            }
        }
    });

    systemPlayer.intent(intent);
};

player.stop = function () {
    systemPlayer.primary.stop();
    drawProgress.clear();
    clearInterval(timer);
    // stop handlers
};


module.exports = player;
